// extracted by css-extract-rspack-plugin
export default {"cls1":"Upsell-cls1_2n-","cls2":"Upsell-cls2_coO Upsell-cls1_2n-"};